import React, { useEffect } from 'react';
import { FAQSection } from '@yme/molecules/faq-section';
import { DigitalDataMutation, buildKey, setDigitalData } from '@yme/utils/common';
import { SECTION_KEY } from './constants';
import { buildAccordionData } from './helpers';
import { SectionStyled } from './styled';
export function FAQContent(props) {
    const { sections, isRightToLeft, onClick, pbDesktop = '32px' } = props;
    const onOpened = (item) => {
        const id = item.children?.props?.cqItems?.text?.id ?? '';
        const topic = typeof item?.title === 'string' ? item.title : '';
        setDigitalData(DigitalDataMutation.FAQ_EXPANDED, {
            id,
            topic,
        });
    };
    useEffect(() => {
        setDigitalData(DigitalDataMutation.FAQ_LISTING, {
            sections,
        });
        // we need to run this hook only once to setup faq listing
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement(React.Fragment, null, sections.map((section, index) => (React.createElement(SectionStyled, { key: buildKey(section.title || SECTION_KEY, index), id: section.title, flexDirection: "column", pb: "24px", pbDesktop: pbDesktop, onClick: onClick },
        React.createElement(FAQSection, { title: section?.title || '', isRightToLeft: isRightToLeft, onOpened: onOpened, accordionData: buildAccordionData(section.items, isRightToLeft) }))))));
}
